function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 59.598,
    y: 352.395,
    style: {
      fill: "#FFC20D"
    },
    width: 51.339,
    height: 51.339
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.598,
    y: 419.595,
    style: {
      fill: "#B169BF"
    },
    width: 51.339,
    height: 51.339
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.928,
    y: 419.595,
    style: {
      fill: "#D14D7B"
    },
    width: 51.339,
    height: 51.339
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 336.928,
    y: 419.595,
    style: {
      fill: "#60A333"
    },
    width: 51.339,
    height: 51.339
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.595,
    y: 419.595,
    style: {
      fill: "#60A333"
    },
    width: 51.339,
    height: 51.339
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B169BF"
    },
    d: "M76.8,512H25.6c-4.713,0-8.533-3.821-8.533-8.533v-51.2c0-4.713,3.821-8.533,8.533-8.533h51.2 c4.713,0,8.533,3.821,8.533,8.533v51.2C85.333,508.179,81.513,512,76.8,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#844A8F"
    },
    d: "M76.8,494.933H34.133v-42.667c0-4.713,3.821-8.533,8.533-8.533H25.6 c-4.713,0-8.533,3.821-8.533,8.533V486.4v17.067c0,4.713,3.821,8.533,8.533,8.533h17.067H76.8c4.713,0,8.533-3.821,8.533-8.533 V486.4C85.333,491.113,81.513,494.933,76.8,494.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B169BF"
    },
    d: "M145.067,512h-51.2c-4.713,0-8.533-3.821-8.533-8.533v-51.2c0-4.713,3.821-8.533,8.533-8.533h51.2 c4.713,0,8.533,3.821,8.533,8.533v51.2C153.6,508.179,149.779,512,145.067,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#844A8F"
    },
    d: "M145.067,494.933H102.4v-42.667c0-4.713,3.821-8.533,8.533-8.533H93.867 c-4.713,0-8.533,3.821-8.533,8.533V486.4v17.067c0,4.713,3.821,8.533,8.533,8.533h17.067h34.133c4.713,0,8.533-3.821,8.533-8.533 V486.4C153.6,491.113,149.779,494.933,145.067,494.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B169BF"
    },
    d: "M213.333,512h-51.2c-4.713,0-8.533-3.821-8.533-8.533v-51.2c0-4.713,3.821-8.533,8.533-8.533h51.2 c4.713,0,8.533,3.821,8.533,8.533v51.2C221.867,508.179,218.046,512,213.333,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#844A8F"
    },
    d: "M213.333,494.933h-42.667v-42.667c0-4.713,3.821-8.533,8.533-8.533h-17.067 c-4.713,0-8.533,3.821-8.533,8.533V486.4v17.067c0,4.713,3.821,8.533,8.533,8.533H179.2h34.133c4.713,0,8.533-3.821,8.533-8.533 V486.4C221.867,491.113,218.046,494.933,213.333,494.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B169BF"
    },
    d: "M281.6,512h-51.2c-4.713,0-8.533-3.821-8.533-8.533v-51.2c0-4.713,3.821-8.533,8.533-8.533h51.2 c4.713,0,8.533,3.821,8.533,8.533v51.2C290.133,508.179,286.313,512,281.6,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#844A8F"
    },
    d: "M281.6,494.933h-42.667v-42.667c0-4.713,3.821-8.533,8.533-8.533H230.4 c-4.713,0-8.533,3.821-8.533,8.533V486.4v17.067c0,4.713,3.821,8.533,8.533,8.533h17.067H281.6c4.713,0,8.533-3.821,8.533-8.533 V486.4C290.133,491.113,286.313,494.933,281.6,494.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5E95"
    },
    d: "M349.867,512h-51.2c-4.713,0-8.533-3.821-8.533-8.533v-51.2c0-4.713,3.821-8.533,8.533-8.533h51.2 c4.713,0,8.533,3.821,8.533,8.533v51.2C358.4,508.179,354.579,512,349.867,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D14D7B"
    },
    d: "M349.867,494.933H307.2v-42.667c0-4.713,3.821-8.533,8.533-8.533h-17.067 c-4.713,0-8.533,3.821-8.533,8.533V486.4v17.067c0,4.713,3.821,8.533,8.533,8.533h17.067h34.133c4.713,0,8.533-3.821,8.533-8.533 V486.4C358.4,491.113,354.579,494.933,349.867,494.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5E95"
    },
    d: "M349.867,443.733h-51.2c-4.713,0-8.533-3.821-8.533-8.533V384c0-4.713,3.821-8.533,8.533-8.533h51.2 c4.713,0,8.533,3.821,8.533,8.533v51.2C358.4,439.913,354.579,443.733,349.867,443.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D14D7B"
    },
    d: "M349.867,426.667H307.2V384c0-4.713,3.821-8.533,8.533-8.533h-17.067 c-4.713,0-8.533,3.821-8.533,8.533v34.133V435.2c0,4.713,3.821,8.533,8.533,8.533h17.067h34.133c4.713,0,8.533-3.821,8.533-8.533 v-17.067C358.4,422.846,354.579,426.667,349.867,426.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5E95"
    },
    d: "M281.6,443.733h-51.2c-4.713,0-8.533-3.821-8.533-8.533V384c0-4.713,3.821-8.533,8.533-8.533h51.2 c4.713,0,8.533,3.821,8.533,8.533v51.2C290.133,439.913,286.313,443.733,281.6,443.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D14D7B"
    },
    d: "M281.6,426.667h-42.667V384c0-4.713,3.821-8.533,8.533-8.533H230.4c-4.713,0-8.533,3.821-8.533,8.533 v34.133V435.2c0,4.713,3.821,8.533,8.533,8.533h17.067H281.6c4.713,0,8.533-3.821,8.533-8.533v-17.067 C290.133,422.846,286.313,426.667,281.6,426.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5E95"
    },
    d: "M418.133,512h-51.2c-4.713,0-8.533-3.821-8.533-8.533v-51.2c0-4.713,3.821-8.533,8.533-8.533h51.2 c4.713,0,8.533,3.821,8.533,8.533v51.2C426.667,508.179,422.846,512,418.133,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D14D7B"
    },
    d: "M418.133,494.933h-42.667v-42.667c0-4.713,3.821-8.533,8.533-8.533h-17.067 c-4.713,0-8.533,3.821-8.533,8.533V486.4v17.067c0,4.713,3.821,8.533,8.533,8.533H384h34.133c4.713,0,8.533-3.821,8.533-8.533V486.4 C426.667,491.113,422.846,494.933,418.133,494.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5E95"
    },
    d: "M384,136.533h-51.2c-4.713,0-8.533-3.821-8.533-8.533V76.8c0-4.713,3.821-8.533,8.533-8.533H384 c4.713,0,8.533,3.821,8.533,8.533V128C392.533,132.713,388.713,136.533,384,136.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D14D7B"
    },
    d: "M384,119.467h-42.667V76.8c0-4.713,3.821-8.533,8.533-8.533H332.8c-4.713,0-8.533,3.821-8.533,8.533 v34.133V128c0,4.713,3.821,8.533,8.533,8.533h17.067H384c4.713,0,8.533-3.821,8.533-8.533v-17.067 C392.533,115.646,388.713,119.467,384,119.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5E95"
    },
    d: "M384,68.267h-51.2c-4.713,0-8.533-3.821-8.533-8.533v-51.2c0-4.713,3.821-8.533,8.533-8.533H384 c4.713,0,8.533,3.821,8.533,8.533v51.2C392.533,64.446,388.713,68.267,384,68.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D14D7B"
    },
    d: "M384,51.2h-42.667V8.533c0-4.713,3.821-8.533,8.533-8.533H332.8c-4.713,0-8.533,3.821-8.533,8.533 v34.133v17.067c0,4.713,3.821,8.533,8.533,8.533h17.067H384c4.713,0,8.533-3.821,8.533-8.533V42.667 C392.533,47.379,388.713,51.2,384,51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5E95"
    },
    d: "M315.733,68.267h-51.2c-4.713,0-8.533-3.821-8.533-8.533v-51.2C256,3.821,259.821,0,264.533,0h51.2 c4.713,0,8.533,3.821,8.533,8.533v51.2C324.267,64.446,320.446,68.267,315.733,68.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D14D7B"
    },
    d: "M315.733,51.2h-42.667V8.533c0-4.713,3.821-8.533,8.533-8.533h-17.067C259.821,0,256,3.821,256,8.533 v34.133v17.067c0,4.713,3.821,8.533,8.533,8.533H281.6h34.133c4.713,0,8.533-3.821,8.533-8.533V42.667 C324.267,47.379,320.446,51.2,315.733,51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5E95"
    },
    d: "M452.267,136.533h-51.2c-4.713,0-8.533-3.821-8.533-8.533V76.8c0-4.713,3.821-8.533,8.533-8.533h51.2 c4.713,0,8.533,3.821,8.533,8.533V128C460.8,132.713,456.979,136.533,452.267,136.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D14D7B"
    },
    d: "M452.267,119.467H409.6V76.8c0-4.713,3.821-8.533,8.533-8.533h-17.067 c-4.713,0-8.533,3.821-8.533,8.533v34.133V128c0,4.713,3.821,8.533,8.533,8.533h17.067h34.133c4.713,0,8.533-3.821,8.533-8.533 v-17.067C460.8,115.646,456.979,119.467,452.267,119.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7DBB34"
    },
    d: "M486.4,512h-51.2c-4.713,0-8.533-3.821-8.533-8.533v-51.2c0-4.713,3.821-8.533,8.533-8.533h51.2 c4.713,0,8.533,3.821,8.533,8.533v51.2C494.933,508.179,491.113,512,486.4,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60A333"
    },
    d: "M486.4,494.933h-42.667v-42.667c0-4.713,3.821-8.533,8.533-8.533H435.2 c-4.713,0-8.533,3.821-8.533,8.533V486.4v17.067c0,4.713,3.821,8.533,8.533,8.533h17.067H486.4c4.713,0,8.533-3.821,8.533-8.533 V486.4C494.933,491.113,491.113,494.933,486.4,494.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7DBB34"
    },
    d: "M486.4,443.733h-51.2c-4.713,0-8.533-3.821-8.533-8.533V384c0-4.713,3.821-8.533,8.533-8.533h51.2 c4.713,0,8.533,3.821,8.533,8.533v51.2C494.933,439.913,491.113,443.733,486.4,443.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60A333"
    },
    d: "M486.4,426.667h-42.667V384c0-4.713,3.821-8.533,8.533-8.533H435.2c-4.713,0-8.533,3.821-8.533,8.533 v34.133V435.2c0,4.713,3.821,8.533,8.533,8.533h17.067H486.4c4.713,0,8.533-3.821,8.533-8.533v-17.067 C494.933,422.846,491.113,426.667,486.4,426.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7DBB34"
    },
    d: "M418.133,443.733h-51.2c-4.713,0-8.533-3.821-8.533-8.533V384c0-4.713,3.821-8.533,8.533-8.533h51.2 c4.713,0,8.533,3.821,8.533,8.533v51.2C426.667,439.913,422.846,443.733,418.133,443.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60A333"
    },
    d: "M418.133,426.667h-42.667V384c0-4.713,3.821-8.533,8.533-8.533h-17.067 c-4.713,0-8.533,3.821-8.533,8.533v34.133V435.2c0,4.713,3.821,8.533,8.533,8.533H384h34.133c4.713,0,8.533-3.821,8.533-8.533 v-17.067C426.667,422.846,422.846,426.667,418.133,426.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7DBB34"
    },
    d: "M418.133,375.467h-51.2c-4.713,0-8.533-3.821-8.533-8.533v-51.2c0-4.713,3.821-8.533,8.533-8.533 h51.2c4.713,0,8.533,3.821,8.533,8.533v51.2C426.667,371.646,422.846,375.467,418.133,375.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60A333"
    },
    d: "M418.133,358.4h-42.667v-42.667c0-4.713,3.821-8.533,8.533-8.533h-17.067 c-4.713,0-8.533,3.821-8.533,8.533v34.133v17.067c0,4.713,3.821,8.533,8.533,8.533H384h34.133c4.713,0,8.533-3.821,8.533-8.533 v-17.067C426.667,354.579,422.846,358.4,418.133,358.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9D84E"
    },
    d: "M76.8,375.467H25.6c-4.713,0-8.533-3.821-8.533-8.533v-51.2c0-4.713,3.821-8.533,8.533-8.533h51.2 c4.713,0,8.533,3.821,8.533,8.533v51.2C85.333,371.646,81.513,375.467,76.8,375.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC20D"
    },
    d: "M76.8,358.4H34.133v-42.667c0-4.713,3.821-8.533,8.533-8.533H25.6c-4.713,0-8.533,3.821-8.533,8.533 v34.133v17.067c0,4.713,3.821,8.533,8.533,8.533h17.067H76.8c4.713,0,8.533-3.821,8.533-8.533v-17.067 C85.333,354.579,81.513,358.4,76.8,358.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9D84E"
    },
    d: "M76.8,443.733H25.6c-4.713,0-8.533-3.821-8.533-8.533V384c0-4.713,3.821-8.533,8.533-8.533h51.2 c4.713,0,8.533,3.821,8.533,8.533v51.2C85.333,439.913,81.513,443.733,76.8,443.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC20D"
    },
    d: "M76.8,426.667H34.133V384c0-4.713,3.821-8.533,8.533-8.533H25.6c-4.713,0-8.533,3.821-8.533,8.533 v34.133V435.2c0,4.713,3.821,8.533,8.533,8.533h17.067H76.8c4.713,0,8.533-3.821,8.533-8.533v-17.067 C85.333,422.846,81.513,426.667,76.8,426.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9D84E"
    },
    d: "M145.067,443.733h-51.2c-4.713,0-8.533-3.821-8.533-8.533V384c0-4.713,3.821-8.533,8.533-8.533h51.2 c4.713,0,8.533,3.821,8.533,8.533v51.2C153.6,439.913,149.779,443.733,145.067,443.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC20D"
    },
    d: "M145.067,426.667H102.4V384c0-4.713,3.821-8.533,8.533-8.533H93.867 c-4.713,0-8.533,3.821-8.533,8.533v34.133V435.2c0,4.713,3.821,8.533,8.533,8.533h17.067h34.133c4.713,0,8.533-3.821,8.533-8.533 v-17.067C153.6,422.846,149.779,426.667,145.067,426.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9D84E"
    },
    d: "M145.067,375.467h-51.2c-4.713,0-8.533-3.821-8.533-8.533v-51.2c0-4.713,3.821-8.533,8.533-8.533 h51.2c4.713,0,8.533,3.821,8.533,8.533v51.2C153.6,371.646,149.779,375.467,145.067,375.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC20D"
    },
    d: "M145.067,358.4H102.4v-42.667c0-4.713,3.821-8.533,8.533-8.533H93.867 c-4.713,0-8.533,3.821-8.533,8.533v34.133v17.067c0,4.713,3.821,8.533,8.533,8.533h17.067h34.133c4.713,0,8.533-3.821,8.533-8.533 v-17.067C153.6,354.579,149.779,358.4,145.067,358.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#45CAE0"
    },
    d: "M221.867,264.533h-51.2c-4.713,0-8.533-3.821-8.533-8.533v-51.2c0-4.713,3.821-8.533,8.533-8.533 h51.2c4.713,0,8.533,3.821,8.533,8.533V256C230.4,260.713,226.579,264.533,221.867,264.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0AADBF"
    },
    d: "M221.867,247.467H179.2V204.8c0-4.713,3.821-8.533,8.533-8.533h-17.067 c-4.713,0-8.533,3.821-8.533,8.533v34.133V256c0,4.713,3.821,8.533,8.533,8.533h17.067h34.133c4.713,0,8.533-3.821,8.533-8.533 v-17.067C230.4,243.646,226.579,247.467,221.867,247.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#45CAE0"
    },
    d: "M290.133,264.533h-51.2c-4.713,0-8.533-3.821-8.533-8.533v-51.2c0-4.713,3.821-8.533,8.533-8.533 h51.2c4.713,0,8.533,3.821,8.533,8.533V256C298.667,260.713,294.846,264.533,290.133,264.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0AADBF"
    },
    d: "M290.133,247.467h-42.667V204.8c0-4.713,3.821-8.533,8.533-8.533h-17.067 c-4.713,0-8.533,3.821-8.533,8.533v34.133V256c0,4.713,3.821,8.533,8.533,8.533H256h34.133c4.713,0,8.533-3.821,8.533-8.533v-17.067 C298.667,243.646,294.846,247.467,290.133,247.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#45CAE0"
    },
    d: "M221.867,196.267h-51.2c-4.713,0-8.533-3.821-8.533-8.533v-51.2c0-4.713,3.821-8.533,8.533-8.533 h51.2c4.713,0,8.533,3.821,8.533,8.533v51.2C230.4,192.446,226.579,196.267,221.867,196.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0AADBF"
    },
    d: "M221.867,179.2H179.2v-42.667c0-4.713,3.821-8.533,8.533-8.533h-17.067 c-4.713,0-8.533,3.821-8.533,8.533v34.133v17.067c0,4.713,3.821,8.533,8.533,8.533h17.067h34.133c4.713,0,8.533-3.821,8.533-8.533 v-17.067C230.4,175.379,226.579,179.2,221.867,179.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#45CAE0"
    },
    d: "M221.867,332.8h-51.2c-4.713,0-8.533-3.821-8.533-8.533v-51.2c0-4.713,3.821-8.533,8.533-8.533h51.2 c4.713,0,8.533,3.821,8.533,8.533v51.2C230.4,328.979,226.579,332.8,221.867,332.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0AADBF"
    },
    d: "M221.867,315.733H179.2v-42.667c0-4.713,3.821-8.533,8.533-8.533h-17.067 c-4.713,0-8.533,3.821-8.533,8.533V307.2v17.067c0,4.713,3.821,8.533,8.533,8.533h17.067h34.133c4.713,0,8.533-3.821,8.533-8.533 V307.2C230.4,311.913,226.579,315.733,221.867,315.733z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.848ac7ef71149ae92ef707d13b5fab88.svg";
export { ForwardRef as ReactComponent };